import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { SignedIn, SignedOut, RedirectToSignIn } from '@clerk/clerk-react';

/**
 * Used when a guest tries to checkout: they are sent here with ?returnUrl=...
 * We redirect to Clerk sign-in, then Clerk sends them back to returnUrl after sign-in.
 */
export default function SignInRedirect() {
  const [searchParams] = useSearchParams();
  const returnUrl = searchParams.get('returnUrl') || window.location.origin + '/';

  return (
    <>
      <SignedIn>
        <RedirectBackTo returnUrl={returnUrl} />
      </SignedIn>
      <SignedOut>
        <RedirectToSignIn signInForceRedirectUrl={returnUrl} />
      </SignedOut>
    </>
  );
}

function RedirectBackTo({ returnUrl }) {
  useEffect(() => {
    try {
      if (returnUrl && (returnUrl.startsWith('/') || returnUrl.startsWith('http'))) {
        window.location.replace(returnUrl);
      } else {
        window.location.replace('/');
      }
    } catch {
      window.location.replace('/');
    }
  }, [returnUrl]);
  return (
    <div className="flex items-center justify-center py-12 text-slate-500 dark:text-slate-400">
      Taking you back…
    </div>
  );
}
